import { ButtonAction } from "./TypeCard";

export function addOnClick(
  action: ButtonAction,
  onClick: () => void
): ButtonAction {
  if ("onClick" in action) {
    if ("linkTo" in action || "href" in action) {
      return {
        ...action,
        onClick: async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          if (action.onClick) await action.onClick(e);
          onClick();
        },
      };
    }
    return {
      ...action,
      onClick: async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (action.onClick) await action.onClick(e);
        onClick();
      },
    };
  }

  return { ...action, onClick: async () => onClick() };
}
